<template>
  <div id="bill" class="div_card">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="160px"
        v-show="dataContent!=null">
      <el-form-item label="報名費用">
        <font size="+0.5">新臺幣 {{dataContent.fee}} 元整</font>
      </el-form-item>
      <el-form-item label="報考系別" prop="deptID">
        <el-select v-model="ruleForm.deptID" placeholder="請選擇報考系別"
          :disabled="ruleForm.type==3"
          style="width: 360px;"
          @change="resetData()">
          <el-option
            v-for="item in deptList"
            :key="item.deptID"
            :label="item.name"
            :value="item.deptID">
          </el-option>
        </el-select>
      </el-form-item> 
      <el-form-item label="身分證字號" prop="idNo">
        <el-col :span="8">
          <el-radio-group v-model="ruleForm.nonResidents"
            :disabled="ruleForm.type>1">
            <el-radio :label="false">本國人</el-radio>
            <el-radio :label="true">其它(EX:居留證號碼)</el-radio>
          </el-radio-group>
        </el-col>
        <el-col class="line" :span="16">
          <el-input v-model="ruleForm.idNo" style="width:9.375em;" :maxlength="10"
            @change="checkId()"
            :disabled="ruleForm.type>1"></el-input>
        </el-col>        
      </el-form-item> 
      <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name" style="width:9.375em;" :maxlength="20"
            :disabled="ruleForm.type>1"></el-input>
      </el-form-item> 
      <el-form-item label="聯絡電話" prop="phoneNo1">
        <el-col :span="6">
          <el-input v-model="ruleForm.phoneNo1" style="width:9.375em;" :maxlength="20"
            :disabled="ruleForm.type>1"></el-input>
        </el-col>
        <el-col class="line" :span="18">
          <font size="+1" color="#003399" style="margin: 0;margin-bottom: 1em;font-size: 100%;font-weight: bolder;">
            (考試訊息聯絡用，請確認手機號碼無誤與保持暢通)
          </font>
        </el-col>        
      </el-form-item> 
      <el-form-item label="E-Mail" prop="eMail">
        <el-col :span="6">
          <el-input v-model="ruleForm.eMail" style="width:15em;" :maxlength="30"
            :disabled="ruleForm.type>1"></el-input>
        </el-col>
        <el-col class="line" :span="18">
          <font size="+1" color="#003399" style="margin: 0;margin-bottom: 1em;font-size: 100%;font-weight: bolder;">
            (查詢密碼用，請確認可以正常收信)
          </font>
        </el-col>
      </el-form-item> 
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="ruleForm.status==0">產生繳費單<i class="el-icon-success el-icon--right"/></el-button>
        <el-button type="primary" @click="print(ruleForm.account)" v-show="ruleForm.status==1">繳費單預覽<i class="el-icon-view"></i></el-button>
        <a :href="'./WebApi/Apply/GetBillFormPDF/'+ruleForm.eId+'/'+ruleForm.account" class="ncut-btn-type" v-show="ruleForm.status==1"><span class="glyphicon glyphicon-download-alt" style="margin-right: 4px;" />繳費單下載<i class="el-icon-download"></i></a>
      </el-form-item>
    </el-form>
    <div>
      <!-- <font style="font-weight:bold; border: 1px solid #2b73af; padding: 0.2em; border-radius: 4px; color: #132c33;">備註</font> -->
      <font style="font-weight:bold; color: #132c33;">備註：</font>
      <div style="padding: 0.5em 0 0;" 
        v-html="dataContent.memo"/>
    </div> 
  </div> 
</template>

<script>
export default {
  name: 'bill',
  data () {
    var checkGroupID = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('報考類別不能空白'));
      } else {
        callback();
      }
    };
    var checkDeptID = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('報考系別不能空白'));
      } else {
        callback();
      }
    };
    var checkIdentify = (idNo) => {
      var idHeader = "ABCDEFGHJKLMNPQRSTUVXYWZIO";  
      var msg = '身份證';

      //驗證填入身分證字號長度及格式
      if (idNo.length != 10) {
        return msg+'長度不足';
      }
      var firstChar = idNo.substring(0, 1);
      var i = idHeader.indexOf(firstChar);
      if (i == -1) {
        return msg+'格式錯誤';
      }

      //這邊把身分證字號轉換成準備要對應的
      var tempNo = (i + 10) + '' + idNo.substr(1, 9);

      var s = parseInt(tempNo.substr(0, 1)) +
		  parseInt(tempNo.substr(1, 1)) * 9 +
		  parseInt(tempNo.substr(2, 1)) * 8 +
		  parseInt(tempNo.substr(3, 1)) * 7 +
		  parseInt(tempNo.substr(4, 1)) * 6 +
		  parseInt(tempNo.substr(5, 1)) * 5 +
		  parseInt(tempNo.substr(6, 1)) * 4 +
		  parseInt(tempNo.substr(7, 1)) * 3 +
		  parseInt(tempNo.substr(8, 1)) * 2 +
		  parseInt(tempNo.substr(9, 1)) +
      parseInt(tempNo.substr(10, 1));

      return ((s % 10) != 0? msg + '格式錯誤': '');        
    };
    var checkIdNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身分證字號不能空白'));
      } else if (0 == this.ruleForm.nonResidents) {
        var msg = checkIdentify(this.ruleForm.idNo)
        if (0 < msg.length) {
          return callback(new Error(msg));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('姓名不能空白'));
      } else {
        callback();
      }
    };
    var checkPhoneNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('聯絡電話不能空白'));
      } else {
        callback();
      }
    };
    var checkEMail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('E-Mail不能空白'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        eId: 0,
        sysId: 0,
        nonResidents: false,
        groupID: 0,
        deptID: null,
        eMail: '',
        type: 0,
        status: 0,
        idNo: '',
        name: '',
        phoneNo1: ''
      },
      rules:{
       idNo:[{validator: checkIdNo,trigger:"blur"}],
       name:[{validator: checkName,trigger:"blur"}],
       phoneNo1:[{validator: checkPhoneNo,trigger:"blur"}],
       deptID:[{validator: checkDeptID,trigger:"blur"}],
       groupID:[{validator: checkGroupID,trigger:"blur"}],
       eMail:[{validator: checkEMail,trigger:"blur"}],
      },
      groupList: null,
      deptList: null,
      dataContent: {
        sysId: 0,
        eid: 0,
        schYY:'',
        schNm:'',
        statusId:0,
        sysTitle:'',
        fee:0,
        bankName:'',
        bankId:'',
        sbId:'',
        bankIden:'',
        defaultType:0
      }
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId;
    },
    setting () {
      return this.$store.getters.getSetting;
    },
    user () {
      return this.$store.getters.getUser;
    },
    enroll () {
      return this.$store.getters.getEnrollInfo;
    }
  },
  methods: {
    resetData() {
      this.ruleForm.nonResidents = false;
      this.ruleForm.idNo = '';
      this.ruleForm.name = '';
      this.ruleForm.phoneNo1 = '';
      this.ruleForm.eMail = '';
      this.ruleForm.status = 0;
      this.ruleForm.type = 0;
    },
    submitForm(ruleForm) {   
      let vm = this
      this.$refs.ruleForm.validate((valid) => {
        vm.ruleForm.eId = vm.setting.enrollID[0].codeName;
        vm.ruleForm.fee = vm.dataContent.fee;
        vm.ruleForm.bankIden = vm.dataContent.bankIden;
        vm.ruleForm.statusID = vm.enroll.statusID;
        if (valid) {
          vm.$http.put('./WebApi/Apply/SetBillData',vm.ruleForm)
                    .then((response) =>{
                      if (0 < response.data.length) {
                        vm.print(response.data);
                        vm.checkId();
                      }
                    })
                    .catch(function (error) {
                      //vm.$message.error('對不起,網路連線失敗');
                      vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,網路連線失敗</strong>',
                                        offset: 150
                                      });
                    })
        } else {
          //vm.$message.error('對不起,驗證失敗');
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,驗證失敗</strong>',
                            offset: 150
                          });
          return false;
        }
      });
    },
    checkId() {
      if ((null != this.ruleForm.idNo) && (10 <= this.ruleForm.idNo.length)) {    
        let vm = this
        this.ruleForm.eId = this.setting.enrollID[0].codeName;;
        this.ruleForm.idNo = this.ruleForm.idNo.toUpperCase();
        this.ruleForm.statusID = this.enroll.statusID;
        this.ruleForm.type = 1;
        this.$http.put('./WebApi/Apply/GetBillDataByIdNo',this.ruleForm)
                  .then((response) =>{
                    if (null != response.data) {
                      vm.ruleForm.account = response.data.account;
                      vm.ruleForm.eMail = response.data.eMail;
                      vm.ruleForm.groupID = response.data.groupID;
                      vm.ruleForm.name = response.data.name;
                      vm.ruleForm.nonResidents = response.data.nonResidents;
                      vm.ruleForm.phoneNo1 = response.data.phoneNo1;
                      vm.ruleForm.stdID = response.data.stdID;
                      vm.ruleForm.status = response.data.status;
                      vm.ruleForm.type = response.data.type;
                    }
                  })
                  .catch(function (error) {                            
                    // vm.$message({
                    //             message: '對不起,網路連線失敗',
                    //             type: 'warning'
                    //             });
                    vm.$notify.error({
                                      title: vm.$t('message.Error_txt'),
                                      dangerouslyUseHTMLString: true,
                                      message: '<strong>對不起,網路連線失敗</strong>',
                                      offset: 150
                                    });
                  });
      }
    },
    resetForm(formName) {
      this.$nextTick(function() {
        this.$refs[formName].resetFields();
      })
    },
    getEnrollInfo: function (eId) {
      return this.$http
                 .get('./WebApi/Apply/GetEnrollInfo/'.concat(eId));
    },
    getDeptById: function (id) {
      return this.$http
                 .get('./WebApi/Apply/GetDeptByGrpID/'.concat(id));
    },
    getGroupSet: function () {
      return this.$http
                 .get('./WebApi/Apply/GetGroupSet/'.concat(this.sysId).concat('/3'));
    },
    print: function(data) {
        let url = './WebApi/Apply/GetBillFormPDF/'.concat(this.setting.enrollID[0].codeName).concat('/').concat(data);
        let params = new URLSearchParams();
        params.append('cdn', this.cdnSelect);

        this.$http.get(url, {    
                        responseType: 'blob',
                        params: params
                  })
                  .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('target','_blank');
                    document.body.appendChild(link);
                    link.click();
                  })
    }
  },
  created () {
    this.ruleForm.eId = this.setting.enrollID[0].codeName;
    this.ruleForm.sysId = this.sysId;
    this.dataContent.eId = this.setting.enrollID[0].codeName;
    this.dataContent.sysId = this.sysId;
    
    console.log('======created BillView=====')
    var vm = this
    this.$http.all([vm.getGroupSet(), vm.getEnrollInfo(vm.setting.enrollID[0].codeName)])
              .then(vm.$http.spread(function (groupInfo, enrollInfo) {
                vm.dataContent = enrollInfo.data       
                vm.groupList = groupInfo.data
                if ((0 == vm.ruleForm.groupID) && (1 == groupInfo.data.length)) {
                  vm.ruleForm.groupID = groupInfo.data[0].groupID
                  vm.$http.all([vm.getDeptById(vm.ruleForm.groupID)])
                      .then(vm.$http.spread(function (deptInfo) {
                      vm.deptList = deptInfo.data  
                  }))
                }
                if ((null != vm.user.dId) && (0 < vm.user.dId)) {            
                  vm.$http.get('./WebApi/Apply/GetBillDataById/'.concat(vm.user.dId))
                          .then(function(response) {
                            if (response.data != null) {
                                  vm.ruleForm.deptID       = response.data.deptID;
                                  vm.ruleForm.account      = response.data.account;
                                  vm.ruleForm.eMail        = response.data.eMail;
                                  vm.ruleForm.groupID      = response.data.groupID;
                                  vm.ruleForm.name         = response.data.name;
                                  vm.ruleForm.nonResidents = response.data.nonResidents;
                                  vm.ruleForm.phoneNo1     = response.data.phoneNo1;
                                  vm.ruleForm.stdID        = response.data.stdID;
                                  vm.ruleForm.status       = response.data.status;
                                  vm.ruleForm.type         = response.data.type;
                                  vm.ruleForm.idNo         = response.data.idNo;
                            } else {
                              vm.$message.error('對不起,讀取分發結果查詢失敗');
                            }
                          })
                          .catch(function (error) {
                            vm.$message.error('對不起,網路連線失敗');
                          })
                }
              }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BillView copy.vue